




























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import Loader from "@/components/Loader.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";

const ContestSetModule = namespace("contentSetModule");
const ProcessModule = namespace("processModule");

@Component({
  components: {
    Loader,
    SuccessMessage
  }
})
export default class ContentSetProcess extends Vue {
  @ContestSetModule.Action public updateProcess;
  @ProcessModule.Action public retrieveProcesses;
  @ProcessModule.Getter public processes;

  get getContentSet(): IContentSet {
    return this.contentSet;
  }

  @Prop() public contentSet: IContentSet;
  @Prop() public loading: boolean;

  @Provide() public currentProcess: number | null = null;

  @Provide() public options = [];

  private lastSaved: Date | null = null;

  @Watch("getContentSet", { deep: true })
  public onContentSetUpdate() {
    this.populateOptions();
  }

  public updateContentSetProcess() {
    if (this.currentProcess && this.currentProcess > 0) {
      this.updateProcess(this.currentProcess).then((result) => {
        if (result) {
          this.lastSaved = new Date();
        }
      });
    }
  }

  public populateOptions() {
    this.retrieveProcesses().then((result) => {
      this.options = this.processes.map((val) => ({
        value: val.processId,
        text: val.name
      }));

      if (this.contentSet && this.contentSet.processId > 0) {
        this.currentProcess = this.contentSet.processId;
      }
    });
  }

  public created() {
    this.populateOptions();
  }
}
